import React, { useState, useContext, createContext } from 'react';
import { Route, Redirect } from 'react-router-dom';

const authContext = createContext();

export const ProvideAuth = ({ children }) => {
  const auth = useProvideAuth();
  return <authContext.Provider value={auth}>{children}</authContext.Provider>;
}

export const useAuth = () => {
  return useContext(authContext);
};

const useProvideAuth = () => {
  const [token, setToken] = useState(localStorage.getItem('__TOKEN__'));

  const signIn = (token) => {
    setToken(token || localStorage.getItem('__TOKEN__'));
  };

  const removeToken = () => {
    localStorage.removeItem('__TOKEN__');
    setToken(null);
  }

  return {
    token,
    signIn,
    removeToken
  }
};

export const PrivateRoute = ({ children, ...rest }) => {
  let auth = useAuth();

  return (
    <Route {...rest} render={({ location }) => {
      if (!auth || !auth.token) return <Redirect to={{ pathname: '/login', state: { from: location } }} />
      return children;
    }} />
  );
};
